import { abilitiesPlugin } from "@casl/vue";
import type AuthUser from "~/types/authUser";

export default defineNuxtPlugin(async (nuxtApp) => {
  const { user } = useUserSession();
  const authUser = user.value as AuthUser | null;
  const ability = defineUserAbility(authUser);

  // install casl for vue
  nuxtApp.vueApp.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  });
});
